/**
 * JD interview email entry.
 *
 * The payment-confirmation email points at `/jd-interview/start`; that route resolves the
 * user's current JD assignment, seeds the interview session, and hands off to the shared
 * `/interview` start screen. The dashboard is never the landing target.
 *
 * Kept dependency-free so route guards can import it without pulling client code.
 */

/** Entry route used by JD emails/deep links. */
export const JD_INTERVIEW_START_PATH = '/jd-interview/start'

/** JD journey dashboard, used when there is no JD to resume (create one instead). */
export const JD_INTERVIEW_JOURNEY_PATH = '/dashboard?journey=jd'

/** True for the entry route and anything nested below it. */
export function isJdInterviewStartPath(pathname: string): boolean {
  return (
    pathname === JD_INTERVIEW_START_PATH ||
    pathname.startsWith(`${JD_INTERVIEW_START_PATH}/`)
  )
}
